import React, { useState } from 'react';
import './FAQ.css';

const faqData = [
  {
    question: "How does AI-powered job matching work?",
    answer:
      "Our AI-powered job matching analyzes skills, experience, and goals to recommend the best opportunities from 33+ job platforms, continuously improving with user interactions.",
  },
  {
    question: "How secure is my personal information?",
    answer:
      "We use enterprise-grade encryption to protect your data. Your personal details are never shared without your explicit consent.",
  },
  {
    question: "Can I apply to jobs directly through the platform?",
    answer:
      "Yes, you can apply directly using our integrated application system that connects with major job portals.",
  },
  {
    question: "How often are job recommendations updated?",
    answer:
      "Recommendations are refreshed daily based on new job listings and your recent activity on the platform.",
  },
  {
    question: "Is the platform free to use?",
    answer:
      "Yes, our basic features are free forever. We also offer premium subscriptions for additional benefits.",
  },
  {
    question: "Do you offer support for interview preparation?",
    answer:
      "Absolutely! We provide AI-curated interview questions, mock tests, and resume tips tailored to your profile.",
  },
  {
    question: "What if I don’t find any relevant jobs?",
    answer:
      "Our algorithm learns from your preferences. Keep updating your profile and we’ll keep improving the matches.",
  },
  {
    question: "Can I track my job applications?",
    answer:
      "Yes, you can view your application history and current status in your dashboard at any time.",
  },
];

const Question = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h2 className="faq-heading">
        Frequently Asked <span className="highlight">Questions</span>
      </h2>
      <div className="faq-grid">
        {faqData.map((item, index) => (
          <div
            className={`faq-box ${openIndex === index ? 'open' : ''}`}
            key={index}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              <h3>{item.question}</h3>
              <span className={`arrow ${openIndex === index ? 'rotate' : ''}`}>
                ▼
              </span>
            </div>
            {openIndex === index && <p className="faq-answer">{item.answer}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Question;
